export default __webpack_public_path__ + "static/media/publication.ac952dd4.jpeg";